<template>
<div class="logo-line">
  <img
    class="logo-el-login"
    src="../../assets/images/pages/login/logo_pc.png" alt="">

  <span class="logo-r-text pc-title white-color">RRT-策略管理系统</span>
</div>
</template>

<script>
export default {
  name: "logoLinePc"
}
</script>

<style lang="scss" scoped>
.logo-line {
  .logo-el-login {
    height: 27px;
  }
  .pc-title {
    display: block;
    font-size: 36px;
    color: #ffffff;
    font-weight: 700;
    margin-top: 10px;
  }
}
</style>
<style lang="scss">

</style>
